export default "__VITE_ASSET__BeSAik3a__"